import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Loading } from "./components";
import { publicRoutes } from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/scss/theme.scss";

const NotFound = lazy(() => import("./pages/Public/NotFound"));
const Error = lazy(() => import("./pages/Public/Error"));
const PrivateLayout = lazy(() => import("./components/layout/Container"));

// Função para fazer split de rotas com array de paths
const expandRoutes = (routesList: any[]) => {
  return routesList.flatMap((route) => {
    const paths = Array.isArray(route.path) ? route.path : [route.path];
    return paths.map((path: string, idx: number) => ({
      ...route,
      path,
      _originalPath: route.path,
      _pathIndex: idx
    }));
  });
};

function App() {

  const { t } = useTranslation();
  const baseUrl = `${document
    .getElementsByTagName("base")[0]
    .getAttribute("href")}`;

  const expandedPublicRoutes = expandRoutes(publicRoutes);

  return (
    <>
      <ToastContainer icon={false} theme="colored" />
      <BrowserRouter basename={baseUrl}>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/500" element={<Error />} />
            <Route path="/404" element={<NotFound />} />

            {expandedPublicRoutes.map((route, idx) => (
                <Route
                  key={`${idx}-${route._pathIndex}`}
                  path={route.path}
                  element={<route.page localizer={t} />}
                />
              )
            )}

            <Route path="/*" element={<PrivateLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

export default App;
